import React from 'react';
import { object } from 'prop-types';
import { Route, Switch, Redirect } from 'library/util/core-router';
import Employees from 'apps/hiring/sections/employees';
import AllEmployees from 'apps/hiring/sections/all-employees';
import Employee from 'apps/hiring/sections/employee';
import Openings from 'apps/hiring/sections/openings';
import Opening from 'apps/hiring/sections/opening';
import Behaviors from 'apps/hiring/sections/behaviors';
import CreateOrg from 'apps/hiring/components/create-org';
import Group from 'apps/hiring/sections/group';
import InvalidSubscription from 'apps/hiring/sections/invalid-subscription';
import withUser from 'util/hoc/with-user';
import withData from 'util/hoc/with-data';
import withConfig from 'util/hoc/with-config';
import { resolve } from 'library/helpers/path-resolver';
import HiringQuery from 'apps/hiring/util/query';
import QueryContext from 'context/query-context';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import HiringHeader from 'apps/hiring/components/header';
import Honeybadger from '@honeybadger-io/js';

class HiringApp extends React.Component {
  static propTypes = {
    graph_data: object,
    graph_loading: PropTypes.bool,
    subscription: object,
    user: object.isRequired,
  };

  state = {
    authorized: false,
    query: HiringQuery,
  };

  static getDerivedStateFromProps(props) {
    return { authorized: props.user.current_role_is_manager };
  }

  componentDidMount() {
    Honeybadger.setContext({
      app: 'hiring',
    });
  }

  render() {
    const { authorized } = this.state;

    const { user, graph_data, graph_loading } = this.props;

    if (graph_loading) {
      return 'Loading';
    }

    if (!authorized)
      return (
        <h1 style={{ textAlign: 'center' }}>
          You are not authorized to view this page.
        </h1>
      );

    if (resolve(user, 'organizations', []).length == 0) {
      return <CreateOrg />;
    }

    let status = resolve(graph_data, 'subscription/status', 'false');
    let subscription = resolve(graph_data, 'subscription');

    return (
      <div className="pairin-hiring">
        <Helmet>
          <body className="application-hiring" />
        </Helmet>
        <HiringHeader />
        {user.is_owner && status !== 'active' && status !== 'trialing' ? (
          <Route
            path={'/hiring'}
            render={() => (
              <Switch>
                <Route
                  path="/hiring/invalid-subscription"
                  component={InvalidSubscription}
                />
                <Redirect to="/hiring/invalid-subscription" />
              </Switch>
            )}
          ></Route>
        ) : (
          <QueryContext.Provider value={HiringQuery}>
            <Route
              path={'/hiring'}
              render={() => (
                <Switch>
                  <Route path="/hiring/openings/:id" component={Opening} />
                  <Route
                    path="/hiring/openings"
                    render={(props) => (
                      <Openings {...props} subscription={subscription} />
                    )}
                  />
                  <Route
                    path="/hiring/employees/all"
                    component={AllEmployees}
                  />
                  <Route path="/hiring/employee/:id" component={Employee} />
                  <Route path="/hiring/groups/:id" component={Group} />
                  <Route
                    path="/hiring/employees"
                    render={(props) => (
                      <Employees {...props} subscription={subscription} />
                    )}
                  />
                  <Route
                    path="/hiring/reports"
                    component={() => (
                      <h3 style={{ height: '1200px' }}>Coming Soon</h3>
                    )}
                  />
                  <Route
                    path="/hiring/targets"
                    render={(props) => (
                      <Behaviors {...props} subscription={subscription} />
                    )}
                  />
                  <Redirect to="/hiring/openings" />
                </Switch>
              )}
            ></Route>
          </QueryContext.Provider>
        )}
      </div>
    );
  }
}

export default withConfig(withUser(withData(HiringApp)));

HiringApp.query = async () =>
  await HiringQuery(`
    query {
     subscription {
       status
       trial_days_remaining
     }
    }
  `);

HiringApp.parseQueryData = (data) => ({
  subscription: resolve(data, 'subscription', {}),
});
